import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let person_id = useDataValue({
    context: 'selected',
    path: 'person_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      person_id,
    },
    pause: !person_id,
  }
}
